import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { ConvergeLogo } from './ConvergeLogo';
import { RegisterButton } from './RegisterButton';
import { NAV } from './data';

export const ConvergeNav = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <header className="sticky top-0 z-40 bg-[#F5F3EB] border-b-2 border-[#111]" data-testid="converge-nav">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 h-[68px] flex items-center justify-between gap-4" aria-label="CONVERGE sections">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0">
          <a href="#overview" aria-label="CONVERGE by EvalentX — back to top" data-testid="nav-logo-link">
            <span className="hidden sm:inline-flex"><ConvergeLogo /></span>
            <span className="sm:hidden inline-flex"><ConvergeLogo compact /></span>
          </a>
        </div>
        <ul className="hidden min-[1360px]:flex items-center">
          {NAV.map(([label, id]) => (
            <li key={id}>
              <a href={`#${id}`} className="px-2.5 py-2 text-[11px] font-bold uppercase tracking-widest whitespace-nowrap hover:bg-[#D7FF38] transition-colors" data-testid={`nav-link-${id}`}>{label}</a>
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-2">
          <RegisterButton label="REGISTER NOW ↗" size="sm" testId="nav-register-btn" className="hidden md:inline-flex whitespace-nowrap" />
          <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-controls="cv-mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'}
            className="min-[1360px]:hidden shrink-0 w-11 h-11 border-2 border-[#111] bg-white flex items-center justify-center shadow-[3px_3px_0_#111]" data-testid="nav-menu-toggle">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>
      {open && (
        <div id="cv-mobile-menu" className="min-[1360px]:hidden border-t-2 border-[#111] bg-[#F5F3EB]" data-testid="nav-mobile-menu">
          <ul className="px-4 py-3">
            {NAV.map(([label, id]) => (
              <li key={id} className="border-b border-[#111]/15 last:border-0">
                <a href={`#${id}`} onClick={() => setOpen(false)} className="cv-display block py-3 text-2xl font-extrabold uppercase" data-testid={`mobile-nav-link-${id}`}>{label}</a>
              </li>
            ))}
          </ul>
          <div className="px-4 pb-5"><RegisterButton label="REGISTER NOW ↗" testId="mobile-nav-register-btn" className="w-full" /></div>
        </div>
      )}
    </header>
  );
};
